/* eslint-disable */
import {propsDecorator} from "@/js/common/Domain/Service/mixins/decorators";
import TourProductsRepository from "@/js/common/Domain/Repository/TourProducts";

@propsDecorator({
	bindings: {
		":el": "toggle:labelText",
		".js-similar-label-text": "text:labelText"
	},
	computeds: {
		labelText: {
			deps: ['similarProducts'],
			get(similarProducts) {
				let tours = similarProducts.length;
				if (!tours) return '';
				let operators = {};
				similarProducts.forEach(similarTour => {
					let {id} = similarTour.get("tour").get('operator');
					operators[id] = true
				});
				operators = _.keys(operators)?.length;
				return `${tours} так${tours.wordEnding("ой;их;их")} же тур${tours.wordEnding(";а;ов")} от ${operators} туроператор${operators.wordEnding("а;ов;ов")}`
			}
		}
	}
})

export default class SimilarToursSelect extends Backbone.Epoxy.View{
	initialize() {
		this.collection = new TourProductsRepository(this.model.get("similarProducts"));
		this.render()
	}
	render() {
		this.$el.html(this.template())
	}
}